/**
 * API base URL normalization
 *
 * The app expects API_BASE_URL to point to the backend `/api` prefix, e.g.
 *   https://your-railway-app.up.railway.app/api
 *
 * This helper makes the app resilient to common misconfigurations like:
 * - trailing slashes
 * - double `/api/api`
 * - missing `/api`
 */
export function normalizeApiBaseUrl(raw) {
  const fallback = "http://localhost:8000/api";
  if (!raw || typeof raw !== "string") return fallback;

  let url = raw.trim();
  if (!url) return fallback;

  // Remove trailing slashes
  url = url.replace(/\/+$/, "");

  // Collapse accidental double `/api/api` at the end
  url = url.replace(/\/api\/api$/, "/api");

  // Ensure it ends with `/api`
  if (!url.endsWith("/api")) {
    url = `${url}/api`;
  }

  return url;
}


